import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  laptop: '1024px',
};

const Container = styled.div`
  margin-top: 32px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  width: 100%;
  padding-left: 32px;
  border-top: 3px solid #E6E6E6;
  // border-bottom: 1px solid #E6E6E6;
  padding-top: 24px;
  padding-bottom: 24px;
`;


const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; // Allow cards to wrap to the next line
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  padding: 0;
  justify-content: flex-start;
  margin: 0;

  @media (max-width: 1024px) {
    gap: 16px;
  }
  @media (max-width: 768px) {
    gap: 12px;
  }
`;
const TimeStamp = styled.div`
  color: #666666;
  font-size: 16px;
  margin-bottom: 24px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 400;
  padding: 0 50px;


`;

const Title = styled.h3`
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 16px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 400;
  padding: 0 50px;


`;


const Card = styled.div`
  flex: 0 0 176px;
  height: 142px;
  background: ${(props) => {
    switch (props.level) {
      case 'Apprentice':
        return '#FFF7E6';
      case 'Practitioner':
        return '#F0F8FF';
      case 'Expert':
        return '#BFF4E0';
      case 'Master':
        return '#BFF4E0';
      default:
        return '#FFF1F0';
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.level) {
        case 'Apprentice':
          return '#FFC849';
        case 'Practitioner':
          return '#2c4cd1';
        case 'Expert':
          return '#5DB594';
        case 'Master':
          return '#5DB594';
        default:
          return '#F54B56';
      }
    }};
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  gap: 12px;
  scroll-snap-align: start;

  @media (max-width: 1024px) {
    flex: 0 0 45%;
    height: 130px;
  }
  @media (max-width: 768px) {
    flex: 0 0 100%;
    height: auto;
  }
`;

const CardTitle = styled.div`
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 400;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: center;
  line-height: 1.4;


`;

const Level = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => {
    switch (props.level) {
      case 'Apprentice':
        return '#FFC849';
      case 'Practitioner':
        return '#2c4cd1';
      case 'Expert':
        return '#5DB594';
      case 'Master':
        return '#5DB594';
      default:
        return '#F54B56';
    }
  }};
  font-family: 'Plus Jakarta Sans';
  text-align: center;
  margin-top: auto;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #1890ff;
  font-size: 14px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  padding: 8px 0;
  margin-top: 16px;
  text-decoration: underline;


`;

const JobRolesSection = styled.div`
  margin-top: 32px;
  padding: 0 50px;
`;

const JobRolesTitle = styled.h3`
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 16px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
`;

const JobRoleCard = styled.div`
  background: #F8F9FF;
  border: 1px solid #E0E4F2;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 12px;
`;

const JobRoleName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  font-family: 'Plus Jakarta Sans', sans-serif;
  margin-bottom: 4px;
`;

const JobRoleDescription = styled.div`
  font-size: 13px;
  color: #666;
  font-family: 'Plus Jakarta Sans', sans-serif;
  line-height: 1.5;
`;

const BehavioralAssessment = ({ data, olderData }) => {
  const [showOlderScores, setShowOlderScores] = useState(false);

  if (!data) return null;

  const formatDateTime = (timestamp) => ({
    date: moment(timestamp).format('DD/MM/YYYY'),
    time: moment(timestamp).format('hh:mm A'),
  });

  const { date, time } = formatDateTime(data.timestamp);

  return (
    <Container>
      <Title>Behavioral Assessment</Title>
      <TimeStamp>
        Time: <strong>{date} | {time}</strong>
      </TimeStamp>
      <CardsContainer>
        {data.categories.map((category, index) => (
          <Card key={index} level={category.level}>
            <CardTitle>{category.name}</CardTitle>
            <Level level={category.level}>{category.level}</Level>
          </Card>
        ))}
      </CardsContainer>

      {data.suitableJobRoles?.length > 0 && (
        <JobRolesSection>
          <JobRolesTitle>Potential Job Roles Matching your Behavioural Profile</JobRolesTitle>
          {data.suitableJobRoles.map((role, index) => (
            <JobRoleCard key={index}>
              <JobRoleName>{role.role_name}</JobRoleName>
              {role.role_description && (
                <JobRoleDescription>{role.role_description}</JobRoleDescription>
              )}
            </JobRoleCard>
          ))}
        </JobRolesSection>
      )}

      {olderData && !showOlderScores && (
        <ToggleButton onClick={() => setShowOlderScores(true)}>
          See older scores
        </ToggleButton>
      )}

      {showOlderScores && olderData && (
        <>
          <TimeStamp style={{ marginTop: '32px' }}>
            Time Stamp: <strong>{olderData.time}</strong>
          </TimeStamp>
          <CardsContainer>
            {olderData.categories.map((category, index) => (
              <Card key={index} level={category.level}>
                <CardTitle>{category.name}</CardTitle>
                <Level level={category.level}>{category.level}</Level>
              </Card>
            ))}
          </CardsContainer>
          <ToggleButton onClick={() => setShowOlderScores(false)}>
            Hide older scores
          </ToggleButton>
        </>
      )}
    </Container>
  );
};

export default BehavioralAssessment;